import { apiClient } from "./api";
import { Chatbot } from "../types";

interface ApiOk<T> {
  ok: true;
  data: T;
}

export const chatbotService = {
  list: (tenantId: string) =>
    apiClient.get<ApiOk<{ chatbots: Chatbot[] }>>(
      `/v1/chatbots/?tenantId=${tenantId}`
    ),

  getById: (chatbotId: string) =>
    apiClient.get<ApiOk<Chatbot>>(`/v1/chatbots/${chatbotId}`),

  update: (
    chatbotId: string,
    body: Partial<
      Pick<
        Chatbot,
        | "system_prompt"
        | "model"
        | "temperature"
        | "max_tokens"
        | "max_history"
        | "flow_id"
      >
    >
  ) =>
    apiClient.patch<ApiOk<Chatbot>>(`/v1/chatbots/${chatbotId}`, body),

  delete: (chatbotId: string) =>
    apiClient.delete(`/v1/chatbots/${chatbotId}`),
};
